import { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import DashboardLayout from 'prefabsComponents/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'prefabsComponents/Navbars/DashboardNavbar';
import Footer from 'prefabsComponents/Footer';
import DataTable from 'prefabsComponents/Tables/DataTable';
import useFetch from 'hooks/useFetch';
import DefaultCell from 'layouts/pages/orders/order-list/components/DefaultCell';
import DataTableLoader from 'components/DataTableLoader';
import DataTableHeaderOptions from 'components/DataTableHeaderOptions';
import DataTableDocumentActions from 'components/DataTableDocumentActions';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const Users = () => {
    const { data, isLoading } = useFetch('/api/maintenance/users/');
    const [dataTableData, setDataTableData] = useState({ columns: [], rows: [] });

    useEffect(() => {
        if(data){
            const renderCell = ({ value }) => <DefaultCell value={value} />;

            const columns = [
                { Header: 'Id', accessor: 'id_usuario', Cell: renderCell },
                { Header: 'Nombre', accessor: 'nombre', Cell: renderCell },
                { Header: 'Usuario', accessor: 'usuario', Cell: renderCell },
                { Header: 'Comuna', accessor: 'comuna', Cell: renderCell },
                { Header: 'RUT', accessor: 'rut_usuario', Cell: renderCell },
                { Header: 'Correo', accessor: 'email_usuario', Cell: renderCell },
                { Header: 'Contraseña Correo', accessor: 'pwdemail_usuario', Cell: renderCell },
                { Header: 'Contraseña', accessor: 'password_usuario', Cell: renderCell },
                { Header: 'Acciones', accessor: 'acciones', Cell: renderCell },
            ];

            const rows = data.map((provider) => ({
                id_usuario: provider.id_usuario,
                nombre: provider.nombre_usuario + ' ' + provider.apellido_usuario,
                usuario: provider.usuario,
                comuna: provider.comuna,
                rut_usuario: provider.rut_usuario,
                email_usuario: provider.email_usuario,
                pwdemail_usuario: provider.pwdemail_usuario,
                password_usuario: provider.password_usuario,
                acciones: (
                    <DataTableDocumentActions
                        actions={[{
                            Icon: EditIcon,
                            onClick: () => {},
                            color: 'primary'
                        }]}
                    />
                )
            }));

            setDataTableData({ columns, rows });
        }
    }, [data]);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <DataTableHeaderOptions
                createNewTitle='Nuevo Usuario'
                dataTableData={dataTableData}
                hasFilters={false}
                getData={() => {}}
                CreateNewModal={() => {}}
            />
            <Card>
                {isLoading ? (
                    <DataTableLoader />
                ) : (
                    <DataTable
                        table={dataTableData}
                        entriesPerPage={true}
                        canSearch={true}
                        showTotalEntries={true}
                    />  
                )}
            </Card>
            <Footer />
        </DashboardLayout>
    );
}

export default Users;
